module.exports = __webpack_public_path__ + "static/world-wide-web-0b8a3ea783faf533062a13dd8c73a563.png";